import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.activation.index'),
        name: 'activation.index',
        component: () =>
            import(
                /* webpackChunkName: "activations" */ '@/views/categories/activations/Index.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.activation.breadcrumb.index'),
                    to: null,
                    disable: false,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.activation.create'),
        name: 'activation.create',
        component: () =>
            import(
                /* webpackChunkName: "activations" */ '@/views/categories/activations/Create.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.category.breadcrumb.index'),
                    to: { name: 'category.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.activation.breadcrumb.category.edit'),
                    to: {
                        name: 'category.edit',
                        params: {
                            id: 'category_id',
                        },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('routes.activation.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.activation.edit') + '/:id',
        name: 'activation.edit',
        component: () =>
            import(
                /* webpackChunkName: "activations" */ '@/views/categories/activations/Edit.vue'
            ),
        meta: {
            requiredAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.activation.breadcrumb.index'),
                    to: { name: 'activation.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.activation.breadcrumb.category.edit'),
                    to: {
                        name: 'category.edit',
                        params: {
                            id: 'category_id',
                        },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('routes.activation.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
